import { theme, rem } from '@nobia/zeus-components/lib/styled'

export default {
  colors: {
    text: theme('colors.black'),
    grayText: '#747474',
    specialText: '#919191',
  },
  typography: {
    pageTitle: {
      fontSize: rem(32),
      fontSizeDesktop: rem(32),
      textTransform: 'none',
      fontWeight: '400',
      letterSpacing: '0.59px',
      letterSpacingDesktop: '0.45px',
      lineHeight: rem(35),
      color: theme('colors.text'),
      maxWidth: rem(327),
      maxWidthDesktop: rem(700),
    },
    subHeadline: {
      textTransform: 'uppercase',
      fontSize: rem(16),
      fontSizeDesktop: rem(18),
      fontWeight: 'normal',
      color: theme('colors.text'),
      letterSpacing: '1.33px',
      letterSpacingDesktop: '3.05px',
    },
    pageDescription: {
      fontSize: rem(16),
      fontSizeDesktop: rem(18),
      fontWeight: 'normal',
      lineHeight: '19px',
      letterSpacing: '0.5px',
      letterSpacingDesktop: '0.5px',
      lineHeightDesktop: '19px',
      color: theme('colors.grayText'),
      maxWidth: '300px',
      maxWidthDesktop: '43.75rem',
    },
    collectionLabel: {
      textTransform: 'none',
      fontWeight: 'normal',
      letterSpacing: 'normal',
      fontSize: rem(18),
    },
    imageLabelText: {
      fontWeight: 'normal',
      color: theme('colors.text'),
      fontSize: rem(14),
      textTransform: 'none',
      letterSpacing: '0',
    },
    modalHeadline: {
      color: theme('colors.text'),
      textTransform: 'none',
      fontWeight: '448',
      fontSizeDesktop: rem(50),
      fontSize: rem(30),
    },
    modalText: {
      fontSize: rem(14),
    },
    mobileImageLabel: {
      fontSize: rem(19),
      fontWeight: 'normal',
    },
    mobileImageLink: {
      fontSize: rem(14),
    },
    numberOfImages: {
      fontSize: rem(14),
      lineHeight: 'inherit',
      height: '14px',
      color: '#000000',
      fontWeight: '400',
    },
  },
  grid: {
    containerMaxWidth: '1097px',
  },
  backgroundElement: {
    display: 'none',
  },
  mainContainer: {
    alignItems: 'center',
    athenaPaddingTablet: '0',
    athenaPaddingDesktop: '0',
  },
  headerContainer: {
    alignItems: 'center',
    textAlign: 'center',
  },
  collectionWrapper: {
    top: 0,
    height: 'auto',
    backgroundColor: 'transparent !important',
    flexDirection: 'column',
    width: '379px',
    alignItems: 'flex-start',
    labelAnimationFrom: {
      marginLeft: '-379px',
      opacity: 1,
    },
    labelAnimationTo: {
      marginLeft: '35px',
      opacity: 1,
    },
  },
  numberOfImages: {
    top: `30px`,
    position: 'absolute',
    margin: '3px 0',
    marginDesktop: '3px 0',
  },
  styledLink: {
    color: theme('colors.specialText'),
    border: 'solid #000',
    borderWidth: '0px 0px 1px 0px',
    marginRight: '0px',
    marginRightDesktop: '0px',
    textAlign: 'left',
    padding: '0px',
    fontWeight: 'normal',
  },
  collectionLabel: {
    margin: '3px 0',
    marginDesktop: '3px 0',
    lineHeight: '54px',
    bottom: '50px',
  },
  filter: {
    header: {
      textAlign: 'center',
    },
    row: {
      align: 'center',
    },
    column: {
      margin: '30px 10px 0',
      marginDesktop: '30px 20px 0',
      color: '#999',
    },
    label: {
      marginBottom: '0',
      fontWeight: 'normal',
      display: 'inline',
      letterSpacing: '0',
    },
    icon: {
      position: '-2px',
    },
    button: {
      radius: '18px',
      fontSize: '14px',
      color: theme('colors.black'),
      padding: '5px 39px 5px 32px',
      border: '1px solid #c2c2c2',
      fontWeight: 'normal',
      textTransform: 'none',
      letterSpacing: '0',
      hover: {
        background: '#f6f6f6',
        opacity: '1',
      },
    },
    type: {
      fontSize: '18px',
      textTransform: 'none',
      letterSpacing: '0.5px',
      marginBottom: '0',
    },
  },
  image: {
    ImageLabel: {
      backgroundColor: '#fff',
      borderRadius: '13px',
      height: '27px',
      padding: '0 15px',
      border: 'none',
    },
    StyledIcon: {
      display: 'inline',
    },
    thumbnail: {
      transition: 'none',
      filter: 'none',
      width: 'auto',
      hover: {
        filter: 'none',
      },
    },
  },
}
